import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HeaderTwo from "./HeaderTwo";
import { Link } from "react-router-dom";

type MenuComponentProps = {
  items: Array<{ name: string; link: string }>;
  open: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

const OverlayStyle = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  right: 0;
  width: 100vw;
  height: 100%;
  z-index: 1;
`;

const MenuStyle = styled.div`
  position: fixed;
  background: #f2f0e9;
  box-sizing: border-box;
  text-align: left;
  top: 0;
  right: 0;
  width: 0;
  height: 100vh;
  z-index: 1;

  &.show {
    animation: fadein 0.3s ease;
    padding: 20px;
    width: 40vw;

    @media (max-width: 768px) {
      width: 75vw;
    }

    @keyframes fadein {
      0% {
        transform: translateX(40vw);
      }
      100% {
        transform: translateX(0);
      }
    }
  }

  &.hide {
    padding: 0;
    width: 0;
    animation: fadeout 0.3s ease;

    @keyframes fadeout {
      0% {
        padding: 20px;
        width: 40vw;
        transform: translateX(0);
      }
      100% {
        transform: translateX(40vw);
      }
    }
  }

  ul {
    list-style: none;
    margin: 30px 0;
    padding: 0;

    li {
      border-bottom: 1px solid #383432;
      padding: 10px 0;
      width: 100%;

      a {
        display: block;
        color: #383432;
        font-size: 18px;
        text-decoration: none;

        &:hover {
          color: #818181;
        }
      }
    }
  }
`;

const Menu: React.FC<MenuComponentProps> = ({ items, open, setOpen }) => {
  const [menuClass, setMenuClass] = useState<string>();

  useEffect(() => {
    if (open === null) return;
    setMenuClass(open ? "show" : "hide");
  });

  const onClickLink = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    itemLink: string
  ) => {
    if (location.pathname === itemLink) event.preventDefault();
  };

  const onClickOverlay = () => {
    setOpen(false);
  };

  if (!open) return;

  return (
    <>
      <OverlayStyle onClick={onClickOverlay} />
      <MenuStyle className={menuClass}>
        <HeaderTwo>MENU</HeaderTwo>
        <ul>
          {items.map((item, index) => {
            return (
              <li key={index}>
                <Link
                  to={item.link}
                  onClick={(event) => onClickLink(event, item.link)}
                >
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </MenuStyle>
    </>
  );
};

export default Menu;
